/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reported: NonNullable<unknown>, listed: NonNullable<unknown> }} Err_Tournament_Archival_Results_Count_Below_RosterInputs */



/**
* | output |
* | --- |
* | "Player count {reported} is below the {listed} players listed" |
*
* @param {Err_Tournament_Archival_Results_Count_Below_RosterInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_archival_results_count_below_roster = /** @type {((inputs: Err_Tournament_Archival_Results_Count_Below_RosterInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Archival_Results_Count_Below_RosterInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le nombre de joueurs ${i?.reported} est inférieur aux ${i?.listed} joueurs listés`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El número de jugadores ${i?.reported} es inferior a los ${i?.listed} jugadores listados`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`O número de jogadores ${i?.reported} é menor que os ${i?.listed} jogadores listados`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il numero di giocatori ${i?.reported} è inferiore ai ${i?.listed} giocatori elencati`)
	return /** @type {LocalizedString} */ (`Player count ${i?.reported} is below the ${i?.listed} players listed`)
});